import RHFDictionary from '../RHFDictionary';
import { useSourceOrders } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    label: 'Name',
    align: 'left',
    minWidth: 160,
    width: 220,
    maxWidth: 320,
  },
];

type RHFSourceOrdersProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Фильтр: только с синхронизацией */
  withSync?: boolean;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFSourceOrders({
  name,
  label = 'Source order',
  multiple = false,
  disabled,
  withSync,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFSourceOrdersProps) {
  const filters = withSync === true ? { withSync: true } : {};

  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useSourceOrders}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={filters}
      drawerWidth={drawerWidth}
    />
  );
}
